var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51269 6.50007C3.51186 5.90731 3.62831 5.32024 3.85533 4.77267C4.08236 4.22511 4.41547 3.72786 4.83549 3.30959C5.25551 2.89132 5.75413 2.56027 6.30263 2.33552C6.85114 2.11078 7.43869 1.99677 8.03144 2.00007C10.5064 2.01882 12.4877 4.07507 12.4877 6.55632V7.00007C12.4877 9.23757 12.9564 10.5376 13.3689 11.2501C13.4127 11.326 13.4359 11.412 13.4359 11.4996C13.436 11.5873 13.4131 11.6734 13.3694 11.7493C13.3257 11.8253 13.2628 11.8884 13.1871 11.9324C13.1113 11.9764 13.0253 11.9998 12.9377 12.0001H3.06269C2.97507 11.9998 2.88907 11.9764 2.81331 11.9324C2.73754 11.8884 2.67468 11.8253 2.631 11.7493C2.58732 11.6734 2.56438 11.5873 2.56445 11.4996C2.56453 11.412 2.58763 11.326 2.63144 11.2501C3.04394 10.5376 3.51269 9.23757 3.51269 7.00007V6.50007Z",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12V12.5C6 13.0304 6.21071 13.5391 6.58579 13.9142C6.96086 14.2893 7.46957 14.5 8 14.5C8.53043 14.5 9.03914 14.2893 9.41421 13.9142C9.78929 13.5391 10 13.0304 10 12.5V12",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.6f2c18f4.svg";
export { ForwardRef as ReactComponent };